import hashCode from '@/utils/hashCode/hashCode';
import { useCompaniesStore } from '@/features/Companies/store';

export const getBlacklistedCompaniesHash = () =>
  hashCode(useCompaniesStore().blacklistedList);
